import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { router } from "./router";
import reportWebVitals from "./reportWebVitals";
import initLazyBackgrounds from "./utils/lazyBackgrounds";

// initialize lazy background loader for elements with `data-bg`
if (typeof window !== "undefined") {
  window.addEventListener("DOMContentLoaded", () => {
    initLazyBackgrounds();
  });
}

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  window.__PRERENDERED__ = true;
  router.load().then(() => {
    ReactDOM.hydrateRoot(rootElement, <App />);
  });
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
